module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage ssTab2E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n    注：本表中所指“连续型电子出版物出版单位”，是指依照《电子出版物出版管理规定》经批准办理审批和履行登记手续的出版单位，法人单位出版连续型电子出版物且不再设立法人出版单位的，其设立的连续型电子出版物编辑部视为连续型电子出版物出版单位。\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物品种：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "type": "input",
      "controls-position": "right",
      "min": 0,
      "precision": 0,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.pzs),
      callback: function($$v) {
        _vm.pzs = $$v
      },
      expression: "pzs"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物出版单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "workers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物业务人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其中取得中级以上资格证书人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherWorkers",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法人身份：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "unitType",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C016']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("演变情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "evolution",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.evolution),
      callback: function($$v) {
        _vm.$set(_vm.params, "evolution", $$v)
      },
      expression: "params.evolution"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalSales", $$v)
      },
      expression: "params.firstTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024年出版单位年销售收入（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalSales",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalSales),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalSales", $$v)
      },
      expression: "params.secondTotalSales"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2023出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.firstTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "firstTotalProfit", $$v)
      },
      expression: "params.firstTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("2024出版单位年度利润（税后）总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "secondTotalProfit",
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "disabled": "",
      "controls-position": "right",
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.secondTotalProfit),
      callback: function($$v) {
        _vm.$set(_vm.params, "secondTotalProfit", $$v)
      },
      expression: "params.secondTotalProfit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("连续型电子出版物"), _c('br'), _vm._v("出版单位（主办单位）"), _c('br'), _vm._v("具有的出版资质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书"
    },
    model: {
      value: (_vm.params.qualificationTs),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationTs", $$v)
      },
      expression: "params.qualificationTs"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "期刊"
    },
    model: {
      value: (_vm.params.qualificationQk),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationQk", $$v)
      },
      expression: "params.qualificationQk"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "音像"
    },
    model: {
      value: (_vm.params.qualificationYx),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationYx", $$v)
      },
      expression: "params.qualificationYx"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "电子"
    },
    model: {
      value: (_vm.params.qualificationDz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationDz", $$v)
      },
      expression: "params.qualificationDz"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "网络"
    },
    model: {
      value: (_vm.params.qualificationWl),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationWl", $$v)
      },
      expression: "params.qualificationWl"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "报纸"
    },
    model: {
      value: (_vm.params.qualificationBz),
      callback: function($$v) {
        _vm.$set(_vm.params, "qualificationBz", $$v)
      },
      expression: "params.qualificationBz"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营收高于出版业务"), _c('br'), _vm._v("的其他主营业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherbusiness",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherbusiness),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherbusiness", $$v)
      },
      expression: "params.otherbusiness"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("除传统光盘载体出版外"), _c('br'), _vm._v("在哪些方面有所拓展：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "新媒体"
    },
    model: {
      value: (_vm.params.expandBusinessMedium),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessMedium", $$v)
      },
      expression: "params.expandBusinessMedium"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "直接通过网络传播的出版物"
    },
    model: {
      value: (_vm.params.expandBusinessWeb),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessWeb", $$v)
      },
      expression: "params.expandBusinessWeb"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "图书出版物(此项由盘配书试点单位选填)"
    },
    model: {
      value: (_vm.params.expandBusinessBook),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessBook", $$v)
      },
      expression: "params.expandBusinessBook"
    }
  }), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "其他"
    },
    model: {
      value: (_vm.params.expandBusinessOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOther", $$v)
      },
      expression: "params.expandBusinessOther"
    }
  }), _vm._v(" "), (_vm.params.expandBusinessOther == '1') ? _c('el-input', {
    staticStyle: {
      "width": "240px",
      "margin-left": "5px"
    },
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "size": "small",
      "placeholder": "请输入其他"
    },
    model: {
      value: (_vm.params.expandBusinessOtherFill),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessOtherFill", $$v)
      },
      expression: "params.expandBusinessOtherFill"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "disabled": "",
      "true-label": "1",
      "false-label": "0",
      "label": "无"
    },
    model: {
      value: (_vm.params.expandBusinessEmpty),
      callback: function($$v) {
        _vm.$set(_vm.params, "expandBusinessEmpty", $$v)
      },
      expression: "params.expandBusinessEmpty"
    }
  }), _c('br')], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("出版单位基本信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298aa68b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/ssBlock/forEdit/ssTab2.vue
// module id = 1697
// module chunks = 1